// Author Shi Wen Long
// Date 2022-01-25 11:42:31

class SithMesStoolDeliverTask {
constructor({
        id = null,
        code = '',
        goodsDescription = '',
        deliverLocation = '',
        count = '',
        length = '',
        width = '',
        height = '',
        volume = '',
        weight = '',
        grossWeight = '',
        consignor = '',
        consignorContact = '',
        consignee = '',
        consigneeContact = '',
        consignStatus = '',
        closeTime = '',
        deliverTime = '',
        changeTime = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.goodsDescription = goodsDescription;
    this.deliverLocation = deliverLocation;
    this.count = count;
    this.length = length;
    this.width = width;
    this.height = height;
    this.volume = volume;
    this.weight = weight;
    this.grossWeight = grossWeight;
    this.consignor = consignor;
    this.consignorContact = consignorContact;
    this.consignee = consignee;
    this.consigneeContact = consigneeContact;
    this.consignStatus = consignStatus;
    this.closeTime = closeTime;
    this.deliverTime = deliverTime;
    this.changeTime = changeTime;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesStoolDeliverTask();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'goodsDescription',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.goodsDescription',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'deliverLocation',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.deliverLocation',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'count',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.count',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'length',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.length',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'width',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.width',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'height',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.height',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'volume',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.volume',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'weight',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.weight',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'grossWeight',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.grossWeight',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'consignor',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.consignor',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'consignorContact',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.consignorContact',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'consignee',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.consignee',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'consigneeContact',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.consigneeContact',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'consignStatus',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.consignStatus',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'closeTime',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.closeTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'deliverTime',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.deliverTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'changeTime',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.changeTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolDeliverTask.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    codeFilter : '',
    goodsDescriptionFilter : '',
    deliverLocationFilter : '',
    countFilter : '',
    lengthFilter : '',
    widthFilter : '',
    heightFilter : '',
    volumeFilter : '',
    weightFilter : '',
    grossWeightFilter : '',
    consignorFilter : '',
    consignorContactFilter : '',
    consigneeFilter : '',
    consigneeContactFilter : '',
    consignStatusFilter : '',
    closeTimeRteFilter : '',
    closeTimeLteFilter : '',
    changeTimeRteFilter : '',
    changeTimeLteFilter : '',
    deliverTimeRteFilter : '',
    deliverTimeLteFilter : '',

};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'goodsDescriptionFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.goodsDescription',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'deliverLocationFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.deliverLocation',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'countFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.count',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'lengthFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.length',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'widthFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.width',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'heightFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.height',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'volumeFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.volume',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'weightFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.weight',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'grossWeightFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.grossWeight',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'consignorFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.consignor',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'consignorContactFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.consignorContact',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'consigneeFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.consignee',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'consigneeContactFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.consigneeContact',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'consignStatusFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.consignStatus',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'closeTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.closeTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'closeTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.closeTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'changeTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.changeTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'changeTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.changeTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'deliverTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.deliverTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'deliverTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolDeliverTask.filter.deliverTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        }

];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'goodsDescription',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.goodsDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'deliverLocation',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.deliverLocation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'count',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.count',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'length',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.length',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'width',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.width',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'height',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.height',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'volume',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.volume',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'weight',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.weight',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'grossWeight',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.grossWeight',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'consignor',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.consignor',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'consignorContact',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.consignorContact',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'consignee',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.consignee',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'consigneeContact',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.consigneeContact',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'consignStatus',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.consignStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'closeTime',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.closeTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'deliverTime',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.deliverTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'changeTime',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.changeTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolDeliverTask.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesStoolDeliverTask, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
